/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.viewer.skins.IconSkin'] = {
  "react": [
    [
      "div",
      "image",
      [],
      {}
    ],
    [
      "div",
      "svg",
      [],
      {}
    ]
  ],
  "exports": {
    "image": {
      "skin": "skins.core.ImageNewSkin"
    },
    "svg": {
      "skin": "skins.viewer.VectorImageShapeBasicSkin"
    }
  },
  "css": {
    "%": "overflow:hidden;",
    "%image": "position:static;box-shadow:#000 0 0 0;",
    "%svg": "position:static;box-shadow:#000 0 0 0;",
    "%[data-state~=\"image\"] %svg": "display:none;",
    "%[data-state~=\"svg\"] %image": "display:none;",
    "%[data-state~=\"svg\"] %svg": "width:100%;height:100%;"
  }
}

    return skins;
});
